module.exports = __webpack_public_path__ + "media/images/icon_dados-c58dd008a0bd583509b9e881de978095.png";